var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.688965,
    y: 0.589844,
    width: 24.0859,
    height: 24.0859,
    rx: 4.37926,
    fill: "#445386"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9833 11.626L18.8747 6.0625H17.7157L13.4667 10.8922L10.0754 6.0625H6.16309L11.2925 13.3666L6.16309 19.2003H7.32202L11.8064 14.0987L15.3886 19.2003H19.3009L13.9833 11.626ZM12.3955 13.4307L11.875 12.7029L7.73996 6.91744H9.52033L12.8584 11.5883L13.3767 12.316L17.7152 18.387H15.9348L12.3955 13.4307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f129e63bb6b63c1c92772a6dde11a69c.svg";
export { ForwardRef as ReactComponent };